import { Controller } from "@hotwired/stimulus"
import shave from 'shave'

export default class extends Controller {
  connect() {
    shave('.show-more', 150);
    if (document.getElementsByClassName('show-more')[0].textContent.length > 150 && document.getElementsByClassName('js-shave-char').length > 0) {
      document.getElementById('show_all').classList.remove('hidden');
    }
  }

  showMore(event) {
    event.currentTarget.classList.toggle('show-more--expanded');
    shave('.show-more', event.currentTarget.classList.contains('show-more--expanded') ? 10000 : 150);
    document.getElementById('show_all').innerText = event.currentTarget.classList.contains('show-more--expanded') ? '← Скрыть' : '→ Показать';
  }
}
